import { Row, Tabs, Col, Form, notification } from "antd"; 
import { PrimaryButton } from "../../../styled/Button.styled";
import {
  LightBlueContainer,
  WhiteContainer,
} from "../../../styled/Container.styled";

import PersonalDetails from "./PersonalDetails";
import VehicleDetails from "./VehicleDetails";
import DocumentDetails from "./DocumentDetails";
import BankDetails from "./BankDetails";
import { useAddDriverMutation, useUpdateDriverByIdMutation } from "../../../../feature/Driver/driverApiSlice";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { useState } from "react";
import appendData from "../../../../utils/appendData";
import BookingHistory from "./BookingHistory";
import styled from "styled-components";

function AddDriver() {
  const [addDriver] = useAddDriverMutation();
  const [updateDriver] = useUpdateDriverByIdMutation();
  const navigate = useNavigate();

  const location = useLocation() as { state?: { isVerifyMode?: boolean } };
  const isVerifyMode = location.state?.isVerifyMode || false;

  const [imageFile, setImageFile] = useState("");
  const [rcImage, setRCImage] = useState("");
  const [rcBackImage, setRCBackImage] = useState("");
  const [touristPermitFrontImage, setTouristPermitFrontImage] = useState("");
  const [touristPermitBackImage, setTouristPermitBackImage] = useState("");
  const [aadharFrontImage, setAadharFrontImage] = useState("");
  const [aadharBackImage, setAadharBackImage] = useState("");
  const [drivingLicenceFrontImage, setDrivingLicenceFrontImage] = useState("");
  const [drivingLicenceBackImage, setDrivingLicenceBackImage] = useState("");
  const [panFrontImage, setPanFrontImage] = useState("");
  const [panBackImage, setPanBackImage] = useState("");
  const [formFilled, setFormFilled] = useState(false);
  const [saveDisable, setSaveDisable] = useState(false);

  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabChange = (key: any) => {
    setActiveTab(key);
  };

  const onClose = () => {
    navigate(-1);
  };

  const personalDetailsResponse = (response: any) => {
    setFormFilled(response);
  };
  const documentDetailsResponse = (res: any) => {
    setFormFilled(res);
  };
  const vehicleDetailsResponse = (res: any) => {
    setFormFilled(res);
  };
  const bankDetailsResponse = (res: any) => {
    setSaveDisable(res);
  };

  
  const isEmpty = (value: any) =>
    value === undefined || value === null || value === "";

  
 const validateAllFields = (forms: any, images: Record<string, string>) => {
  const {
    personalDetailForm,
    vehicleDetailForm,
    documentDetailForm,
    bankDetailForm,
  } = forms;

  let firstInvalidTab: string | null = null;

 
  const personalLabels: Record<string, string> = {
    firstName: "First Name",
    lastName: "Last Name",
    dob: "Date of Birth",
    phone: "Phone Number",
    email:"Email",
    address: "Address",
    state: "State",
    dateOfJoining:"Date of Joining",

  
  };

  const vehicleLabels: Record<string, string> = {
    vehicleNumber: "Vehicle Number",
    vehicleMake: "Vehicle Make",
    vehicleYear: "Vehicle Year",
    vehicleModel:"Vehicle Model",
    fuelType: "Fuel Type",
    taxiServiceTypeDTOList: "Service Type",
    rcNumber:"RC Number",
 
  };

  const documentLabels: Record<string, string> = {
    aadhaarNumber: "Aadhaar Number",
    panNumber: "PAN Number",
    drivingNumber: "Driving Licence Number",
  
  };

  const bankLabels: Record<string, string> = {
    accountNumber: "Account Number",
    ifscCode: "IFSC Code",
    bankName: "Bank Name",
    branchName: "Branch Name",
    address: "Address",
    accountHolderName: "Account Holder Name",

  };

  const markEmptyFields = (
    form: any,
    values: any,
    labels: Record<string, string>,
    tabKey: string
  ) => {
    const errors: { name: string; errors: string[] }[] = [];

    for (const key in values) {
      // Only validate fields that are defined in the labels object
      if (labels.hasOwnProperty(key) && isEmpty(values[key])) {
        errors.push({
          name: key,
          errors: [`${labels[key]} is required`],
        });
        if (!firstInvalidTab) firstInvalidTab = tabKey;
      }
    }

    if (errors.length > 0) {
      form.setFields(errors);
    }
  };

 
  markEmptyFields(
    personalDetailForm,
    personalDetailForm.getFieldsValue(),
    personalLabels,
    "tab1"
  );
  if (isEmpty(images.imageFile)) {
    if (!firstInvalidTab) firstInvalidTab = "tab1";
    notification.error({
      message: "Missing Photo",
      description: "Profile image is required",
    });
  }

  markEmptyFields(
    vehicleDetailForm,
    vehicleDetailForm.getFieldsValue(),
    vehicleLabels,
    "tab2"
  );
  
  const vehicleData = vehicleDetailForm.getFieldsValue();
  const selectedServices = vehicleData.taxiServiceTypeDTOList || [];
  const isOutstationSelected = selectedServices.includes("OUTSTATION_TAXI");
  
  // The Vehicle tab only offers a tourist permit FRONT upload (the back one is commented out, and
  // the driver app collects a single permit photo), so only the front can be required.
  const missingVehicleImages = [
    isEmpty(images.rcImage) && "RC front",
    isEmpty(images.rcBackImage) && "RC back",
    isOutstationSelected && isEmpty(images.touristPermitFrontImage) && "Tourist Permit",
  ].filter(Boolean);
  if (missingVehicleImages.length > 0) {
    if (!firstInvalidTab) firstInvalidTab = "tab2";
    notification.error({
      message: "Vehicle Document Missing",
      description: `Please upload: ${missingVehicleImages.join(", ")}`,
    });
  }

  markEmptyFields(
    documentDetailForm,
    documentDetailForm.getFieldsValue(),
    documentLabels,
    "tab3"
  );
  if (
    isEmpty(images.aadharFrontImage) ||
    isEmpty(images.aadharBackImage) ||
    isEmpty(images.drivingLicenceFrontImage) ||
    isEmpty(images.panFrontImage)
  ) {
    if (!firstInvalidTab) firstInvalidTab = "tab3";
    notification.error({
      message: "Document Images Missing",
      description: "Please upload Aadhaar, PAN, and DL images",
    });
  }

  markEmptyFields(
    bankDetailForm,
    bankDetailForm.getFieldsValue(),
    bankLabels,
    "tab4"
  );

  return firstInvalidTab;
};




  const tabItems = [
    {
      label: "Personal",
      disabled: true,
      key: "tab1",
      children: (
        <WhiteContainer>
          <PersonalDetails
            setImageFile={setImageFile}
            personalDetailsResponse={personalDetailsResponse}
          />
        </WhiteContainer>
      ),
    },
    {
      label: "Vehicle ",
      disabled: true,
      key: "tab2",
      children: (
        <WhiteContainer>
          <VehicleDetails
            setRCImage={setRCImage}
            setRCBackImage={setRCBackImage}
            setTouristPermitFrontImage={setTouristPermitFrontImage}
            setTouristPermitBackImage={setTouristPermitBackImage}
            vehicleDetailsResponse={vehicleDetailsResponse}
          />
        </WhiteContainer>
      ),
    },
    {
      label: "Document ",
      disabled: true,
      key: "tab3",
      children: (
        <WhiteContainer>
          <DocumentDetails
            setAadharFrontImage={setAadharFrontImage}
            setAadharBackImage={setAadharBackImage}
            setDrivingLicenceFrontImage={setDrivingLicenceFrontImage}
            setPanFrontImage={setPanFrontImage}
            documentDetailsResponse={documentDetailsResponse}
          />
        </WhiteContainer>
      ),
    },
    {
      label: "Bank ",
      disabled: true,
      key: "tab4",
      children: (
        <WhiteContainer>
          <BankDetails bankDetailsResponse={bankDetailsResponse} />
        </WhiteContainer>
      ),
    },
    {
      label: "Booking History ",
      disabled: true,
      key: "tab5",
      children: (
        <WhiteContainer>
          <BookingHistory />
        </WhiteContainer>
      ),
    },
  ];

  const handleNextTab = () => {
    
    const tabs = ["tab1", "tab2", "tab3", "tab4"];
    const currentIndex = tabs.indexOf(activeTab);
    const nextIndex = currentIndex === tabs.length - 1 ? 0 : currentIndex + 1;
    setActiveTab(tabs[nextIndex]);
    setFormFilled(false);
  };

  const handlePrevTab = () => {
    const tabs = ["tab1", "tab2", "tab3", "tab4"];
    const currentIndex = tabs.indexOf(activeTab);
    const prevIndex = currentIndex === 0 ? 0 : currentIndex - 1;
    setActiveTab(tabs[prevIndex]);
  };

  return (
    <Form.Provider
      onFormFinish={async (name, { forms }) => {
        if (name === "submitForm" && !isVerifyMode) {
          const missing = validateAllFields(forms, {
            imageFile,
            rcImage,
            rcBackImage,
            touristPermitFrontImage,
            touristPermitBackImage,
            aadharFrontImage,
            aadharBackImage,
            drivingLicenceFrontImage,
            drivingLicenceBackImage,
            panFrontImage,
          });
          if (missing) {
            setActiveTab(missing);
            notification.error({
              message: "Incomplete Form",
              description: "Please fill all required fields before saving.",
              placement: "topLeft",
            });
            return;
          }

          const {
            personalDetailForm,
            vehicleDetailForm,
            documentDetailForm,
            bankDetailForm,
          } = forms;

          // submit() below does not wait for the rules, so check them first and stop on any error.
          try {
            await personalDetailForm.validateFields();
          } catch {
            setActiveTab("tab1");
            notification.error({
              message: "Invalid details",
              description: "Please correct the highlighted fields in Personal Details.",
              placement: "topLeft",
            });
            return;
          }

          personalDetailForm.submit();
          vehicleDetailForm.submit();
          documentDetailForm.submit();
          bankDetailForm.submit();

          const driverData = personalDetailForm.getFieldsValue();
          const vehicleData = vehicleDetailForm.getFieldsValue();
          const documentData = documentDetailForm.getFieldsValue();
          const bankData = bankDetailForm.getFieldsValue();

          const obj = {
            ...driverData,
            image: imageFile,
            dob: dayjs(driverData.dob).format("DD/MM/YYYY"),
            cabStand: driverData.cabStand,
            isActive: true,
            isVerified: true,
            categoryName: vehicleData.vehicleCategory,
            vehicleDto: {
              ...vehicleData,
              vehicleMake: [{ id: vehicleData.vehicleMake }],
              vehicleYear: dayjs(vehicleData.vehicleYear).format("YYYY"),
              touristPermitDTO: {
                touristPermitNumber: vehicleData.touristPermitNumber || "",
                touristPermitFrontImage: touristPermitFrontImage,
                touristPermitBackImage: touristPermitBackImage,
              },
              rcImage: {
                rcNumber: vehicleData.rcNumber,
                rcFrontImage: rcImage,
                rcBackImage: rcBackImage,
              },
            },
            bankDetails: bankData,
            ...documentData,
            aadhaarFrontImage: aadharFrontImage,
            aadhaarBackImage: aadharBackImage,
            drivingFrontImage: drivingLicenceFrontImage,
            drivingBackImage: drivingLicenceBackImage,
            panImage: panFrontImage,
          };

          addDriver(obj)
            .unwrap()
            .then(() => {
              notification.success({
                message: "Successfully Added!",
                placement: "bottomLeft",
              });
              navigate(-1);
            })
            .catch((error: any) =>
              notification.error({
                message: "Error!",
                description: error?.data?.message || "Something went wrong",
                placement: "bottomLeft",
              })
            );
        }
      }}
    >
      <Row justify="end" gutter={20} className="button-bottom-margin">
        <Col>
          {activeTab !== "tab1" ? (
            <PrimaryButton onClick={handlePrevTab}>Back</PrimaryButton>
          ) : (
            <PrimaryButton onClick={onClose}>Close</PrimaryButton>
          )}
        </Col>
        <Col>
          {activeTab === "tab4" ? (
            <Form name="submitForm">
              <PrimaryButton htmlType="submit">Save</PrimaryButton>
            </Form>
          ) : (
            <PrimaryButton onClick={handleNextTab}>Next</PrimaryButton>
          )}
        </Col>
      </Row>

      <LightBlueContainer>
        <Tabs defaultActiveKey={activeTab} activeKey={activeTab} items={tabItems} onChange={handleTabChange} />
      </LightBlueContainer>
    </Form.Provider>
  );
}

export default AddDriver;
